import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import LangSwitch from '../../../../shared/lang/switch';
import InputField from '../../../../shared/form-elements/input';
import CheckboxField from '../../../../shared/form-elements/checkbox';
import SelectField from '../../../../shared/form-elements/select/field';
import UploadField from '../../../../shared/form-elements/upload';
import TextField from '../../../../shared/form-elements/textarea';

const isEverad = process.env.CPA_ENV === 'everad';

const getTranslationFieldName = lang => lang !== 'en' ? `translations.${lang}.` : '';

const translationSwitcher = (lang, intl) => (
	<div>
		<div className='ui-form__element'>
			<Field
				name={`${getTranslationFieldName(lang)}title`}
				placeholder={intl('Title')}
				component={InputField}
			/>
		</div>
		<div className='ui-form__element'>
			<Field
				name={`${getTranslationFieldName(lang)}description`}
				placeholder={intl('Description')}
				component={TextField}
			/>
		</div>
	</div>
);

const Main = props => {
	return (
		<div className='goods-form-wrap'>
			<div className='goods-form-wrap__langs'>
				<LangSwitch
					langs={props.mainTabLangs}
					onChangeLang={props.mainFormChangeLanguage}
				/>
			</div>
			<form
				onSubmit={props.handleSubmit(props.mainFormSubmit)}
				className='ui-form goods-form__main clearfix'
			>
				<div className='goods-form__main-fields'>
					{(translationSwitcher(props.currentLanguage, props.intl))}
					<div className='selectors-wrapper'>
						<div className='ui-form__element status'>
							<Field
								name='status'
								placeholder={props.intl('Status')}
								component={SelectField}
								searchable={false}
								clearable={false}
								multi={false}
								options={props.loadStatusOptions}
							/>
						</div>
						<div className='ui-form__element category'>
							<Field
								name='category'
								placeholder={props.intl('Category')}
								component={SelectField}
								searchable={true}
								clearable={false}
								multi={false}
								options={props.goodCategoriesLookup}
							/>
						</div>
					</div>
					<div className='ui-form__element price'>
						<Field
							name='price'
							placeholder={props.intl('Price')}
							component={InputField}
						/>
					</div>
					<div className='ui-form__element price'>
						<Field
							name='rank_id'
							placeholder={props.intl('Rank_id')}
							component={SelectField}
							searchable={false}
							multi={false}
							options={props.ranksOptions}
						/>
					</div>
					{isEverad ? (
						<div className='ui-form__element price everad-gift-fields'>
							<Field
								name='amount_left'
								placeholder={props.intl('Amount left')}
								component={InputField}
							/>
							<Field
								name="is_on_wheel"
								placeholder={ props.intl('Is on wheel?') }
								component={CheckboxField}
								normalize={v => !!v }
							/>
							<Field
								name="is_highlighted"
								placeholder={ props.intl('Is highlighted') }
								component={CheckboxField}
								normalize={v => !!v }
							/>
						</div>
					) : (
						<div className='ui-form__element price'>
							<Field
								name='is_exchange_allowed'
								placeholder={props.intl('Is exchange to USD allowed?')}
								normalize={v => !!v}
								component={CheckboxField}
							/>
						</div>
					)}
					{!isEverad && (
						<div className='ui-form__element price'>
							<Field
								name='is_prioritized'
								placeholder={props.intl('Priority?')}
								normalize={v => !!v}
								component={CheckboxField}
							/>
						</div>
					)}
				</div>
				<div className='goods-form__main-meta'>
					<div className='ui-form__element'>
						<Field
							name='image'
							component={UploadField}
							placeholder={props.intl('Upload')}
							preparationFile={props.preparationFile}
						/>
					</div>
				</div>
				<div className='goods-form__footer'>
					<div className='ui-form__element buttons-wrap'>
						{props.can('edit') && (
							<button className='ui-btn ui-btn-primary'>
								{props.intl(props.data.id ? 'Update' : 'Save')}
							</button>
						)}
						<Link
							to='/goods'
							className='ui-btn ui-btn-cancel'
						>{props.intl('Cancel')}</Link>
					</div>
				</div>
			</form>
		</div>
	);
};

Main.propTypes = {
	handleSubmit: PropTypes.func,
	mainFormSubmit: PropTypes.func,
	mainTabLangs: PropTypes.array,
	mainFormChangeLanguage: PropTypes.func,
	intl: PropTypes.func,
	preparationFile: PropTypes.func,
	data: PropTypes.object,
	can: PropTypes.func,
	loadStatusOptions: PropTypes.array,
	ranksOptions: PropTypes.array,
	goodCategoriesLookup: PropTypes.func,
	currentLanguage: PropTypes.string
};

export default reduxForm({
	form: 'goodMainForm'
})(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/components/forms/general/main.js